var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ConfigureComponentBase } from '../../../../../../shared/configure-component-base';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { finalize } from 'rxjs/operators';
var BatchEditEventModalComponent = /** @class */ (function (_super) {
    __extends(BatchEditEventModalComponent, _super);
    function BatchEditEventModalComponent(injector, eventGroupService, eventService, bsModalRef) {
        var _this = _super.call(this, injector) || this;
        _this.eventGroupService = eventGroupService;
        _this.eventService = eventService;
        _this.bsModalRef = bsModalRef;
        _this.batchEditedEvent = new EventEmitter();
        return _this;
    }
    BatchEditEventModalComponent.prototype.ngAfterViewInit = function () {
        this.loadGroups();
    };
    BatchEditEventModalComponent.prototype.close = function () {
        this.bsModalRef.hide();
    };
    BatchEditEventModalComponent.prototype.loadGroups = function () {
        var _this = this;
        this.eventGroupService.getEventGroups(this.configureId)
            .subscribe(function (result) {
            _this.groupList = result;
        });
    };
    BatchEditEventModalComponent.prototype.save = function () {
        var _this = this;
        if (!this.eventGroupChecked) {
            this.batchEditEventDto.groupId = undefined;
        }
        this.saving = true;
        this.eventService.batchEditEvents(this.batchEditEventDto)
            .pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function () {
            _this.batchEditedEvent.emit();
            abp.notify.success(_this.l('SavedSuccessfully'));
            _this.close();
        });
    };
    __decorate([
        Input()
    ], BatchEditEventModalComponent.prototype, "configureId", void 0);
    __decorate([
        Output()
    ], BatchEditEventModalComponent.prototype, "batchEditedEvent", void 0);
    BatchEditEventModalComponent = __decorate([
        Component({
            selector: 'batch-edit-event-modal',
            template: "<div class=\"modal-content fe-modal-container designer-input-wrap\" bs-modal-drag> <div class=\"modal-header fe-modal-header border-bottom\"> <h4 class=\"fe-modal-header-title\"> <span>{{lc('BatchEdit')}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"modal-body\"> <form novalidate> <div class=\"event-transverse clearfix\"> <div class=\"event-input\"> <p-checkbox [(ngModel)]=\"eventGroupChecked\" binary=\"true\" name=\"groupCheckbox\" label=\"{{lc('EventGroup')}}\"></p-checkbox> <ng-select name=\"groupSelect\" [items]=\"groupList\" bindLabel=\"name\" bindValue=\"id\" [searchable]=\"true\" placeholder=\"{{lc('PleaseSelectGroup')}}\" [disabled]=\"!eventGroupChecked\" [(ngModel)]=\"batchEditEventDto.groupId\" [clearable]=\"true\" [notFoundText]=\"l('NoData')\"> <ng-template ng-option-tmp ng-label-tmp let-item=\"item\"> {{item.name}} </ng-template> </ng-select> </div> </div> </form> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"saving || (eventGroupChecked && !batchEditEventDto.groupId) || !eventGroupChecked\" (click)=\"save()\"> {{lc('Save')}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l('Cancel')}} </button> </div> </div> </div> ",
            styles: [".event-transverse{ width: 100%; margin: 1rem auto; .event-input{ input{ width: 100%; height: 30px; } input:disabled { background-color: #f9f9f9; } select { height: 30px; } } } "]
        })
    ], BatchEditEventModalComponent);
    return BatchEditEventModalComponent;
}(ConfigureComponentBase));
export { BatchEditEventModalComponent };
